import {devLog} from "../../../../../../utils/devLog/devLog";

export default (args: {setDraggedType: Function, setDragged: Function}) => (itemId: string, itemType?: 'candidacy' | 'potential') => {

  devLog("dragged", itemId, itemType);

  args.setDraggedType(itemType);
  args.setDragged(itemId);
}